import {type ISystemGroup, GroupType} from '../schema';
import {canManageSystemGroups} from './canManageSystemGroups';

/** can group be edited by current user */
export const canEditSystemGroup = (group?: ISystemGroup) =>
	!!group && group.type === GroupType.USER_CREATED && canManageSystemGroups();
